<template lang="pug">
div
  el-row
    el-col(:sm="24")
      p.info Número:
        span {{documento.numeroDeclaracao || '-'}}
    el-col(:sm="24")
      p.info Processo:
        span {{documento.numeroProcesso || '-'}}
    el-col(:sm="24")
      p.info Interessado:
        span {{documento.nomeRazaoSocialInteressado || '-'}}
    el-col(:sm="24")
      p.info Regularização Fundiária:
        span {{tipoCadastro}}
    el-col(:sm="24" v-if="documento.numeroReciboCar")
      p.info Número recibo CAR:
        span {{documento.numeroReciboCar || '-'}}
    div(v-else)
      el-col(:sm="24")
        p.info Nome do Imóvel:
          span {{documento.nomeImovel || '-'}}
      el-col(:sm="24")
        p.info Município:
          span {{documento.nomeMunicipioImovel || '-'}}
      el-col(:sm="24")
        p.info Área do Imóvel:
          span {{areaFormatada}} hectare(s)
    el-col(:sm="24")
      p.info Data da expedição:
        span {{documento.dataCriacao}}
    slot(name="baixar")

    el-row.dados-doc
      .link-download
        font-awesome-icon(icon="cloud-download-alt")
        a(@click="downloadDoc(documento.id)") &nbsp Baixar Documento

</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import EnumFormatter from '@/utils/EnumFormatter'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import utils from '@/utils/utils'

export default {
  mixins: [
    AppNotificacao
  ],
  async created () {
    if (_.isEmpty(this.documento)) { // eslint-disable-line
      await this.consultaDocumento(this.$route.params.protocolo)
    }
  },
  computed: {
    ...mapGetters({
      documento: 'documentosAutenticaveis/item'
    }),
    tipoCadastro () {
      return EnumFormatter.getRegularizacaoFundiaria(this.documento.tipoCadastro)
    },
    areaFormatada () {
      const options = {
        prefix: '',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 4
      }

      return utils.format(this.documento.areaImovel, options)
    }
  },
  methods: {
    ...mapActions({
      consultaDocumento: 'documentosAutenticaveis/consultaAutenticidade',
      baixarDocumento: 'documentosAutenticaveis/download'
    }),
    downloadDoc (id) {
      this.baixarDocumento(id)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/_variables.scss";

.info {
  font-weight: bold;
  font-size: 16px;
  margin: 10px 0 5px 0;
}
.title {
  font-size: 25px;
}
span {
  font-weight: normal;
  margin-left: 5px;
}

.link-download, a {
  margin-top: 15px;
  color: $color-primary;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    color: #33b281;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/DeclaracaoTramiteAutentica.vue